import React, { useEffect ,useState} from 'react';
import { CssBaseline } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MenuIcon from '@material-ui/icons/Menu';
import Header from './Header';
import Drawer from './Drawer';
import MainContent from './MainContent';
import CustomSnackbar from '../Common/CustomSnackbar';
import snackbarProps from '../../selectors/snackbar';
import { logout } from '../../actions/authentication';
import { requestPackage } from '../../actions/packageInfo';
import { requestSubscriptionInfo } from '../../actions/subscription';
import { currentUserSelector } from '../../selectors/currentUserSelector';
import useStyles from './styles';

function Layout() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const snackbarProp = useSelector(snackbarProps);
  const currentUser = useSelector(currentUserSelector);
  //const [mobileOpen, setMobileOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  
  const handleDrawerToggle = ()=>{
    setIsMenuOpen(!isMenuOpen)
  }

  useEffect(() => {
    dispatch(requestPackage());
    dispatch(requestSubscriptionInfo());
  }, [dispatch]);

  const handleLogOut = () => {
    dispatch(logout());
  };
  // const handleSidebarToggle = () => {
  //   setIsMenuOpen(!open)
  // };

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* <Header
        handleLogOut={handleLogOut}
        currentUser={currentUser}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      /> */}
      <Drawer
        handleLogOut={handleLogOut}
        currentUser={currentUser}
        //mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
        isMenuOpen={isMenuOpen}
      />
      {/* <MenuIcon onClick={()=>handleSidebarToggle()} className={open?classes.content:classes.sidebarCollapse} style={{color:'#000',zIndex:999999,top:46,position:'relative'}} /> */}
      <MainContent
        currentUser={currentUser}
        isMenuOpen={isMenuOpen}
      />
      <CustomSnackbar
        open={snackbarProp.open}
        message={snackbarProp.message}
        severity={snackbarProp.severity}
      />
    </div>
  );
}

export default Layout;
